// @ts-ignore
import delay from 'lodash/delay';
import {ShowHide} from "./ShowHideClass";

export class Accordion {
  accordion: HTMLElement;
  items: NodeListOf<HTMLElement>
  triggers: NodeListOf<HTMLElement>

  showHides: ShowHide[];

  constructor(accordion) {
    this.accordion = accordion;
    this.items = this.accordion.querySelectorAll('[data-accordion-item]');
    this.triggers = this.accordion.querySelectorAll('[data-accordion-header]');
    this.showHides = []
    this.init();
    this.addTriggerEvents();
  }

  init() {
    this.items.forEach((item) => {
      let header: HTMLElement = item.querySelector('[data-accordion-header]')
      let showHide: ShowHide = new ShowHide(
        header,
        item.querySelector('[data-accordion-body]'),
        false,
        true,
        false
      );
      this.showHides.push(showHide);
    });
  }

  addTriggerEvents() {
    this.triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => {
        let scroll: boolean = false;
        this.showHides.forEach((showHide) => {
          if (showHide.trigger === trigger && showHide.isActive === false) {
            showHide.show();
            scroll = true;
          }
          else {
            showHide.hide();
          }
        });
        if (scroll) {
          delay(() => {
            window.scrollTo({
              top: trigger.getBoundingClientRect().top + (window.scrollY || document.documentElement.scrollTop) - 102,
              behavior: "smooth"
            });
          }, 250);
        }
      });
    });
  }

}
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll<HTMLElement>('[data-accordion]').forEach((accordion) => {
    new Accordion(accordion);
  });
});
